import { useEffect } from 'react'
import { useCheckout } from 'lib/modules/checkout'

export const BillingSameAsShippingHandler = () => {
  const { billingAddress, shippingAddress, setBillingAddressSameAsShipping } = useCheckout()

  useEffect(() => {
    if (!shippingAddress.isFetching) {
      setBillingAddressSameAsShipping()
    }
    // eslint-disable-next-line
  }, [shippingAddress.isFetching])

  useEffect(() => {
    if (!billingAddress.isFetching) {
      setBillingAddressSameAsShipping()
    }
    // eslint-disable-next-line
  }, [billingAddress.isFetching])

  return null
}
